<template>
  <div class="suport">
    <div class="content">
      <h2 class="title">智慧停车开放平台支持功能</h2>
      <div class="suportMsg">
      <el-tabs v-model="activeName" @tab-click="handleClick" tab-position="left">
        <el-tab-pane v-for="(item, index) in menuList" v-if="!item.hidden" 
          :key="item.index + index" :label="item.name" :name="index + ''">
          <el-row v-for="(one,index2) in item.menu" :key="index + '-' + index2" v-if="one.sub.length > 0">
            <div v-if="!one.hidden">
            <el-divider content-position="left"><i  class="el-icon-menu"></i>&emsp;{{one.title}}</el-divider>
            <el-col style="padding-left: 1rem">
            <div v-for="(two, index3) in one.sub" :key="index + '-' + index2 + '-' + index3" style="display: inline;">
              <div v-if="!two.hidden" style="display: inline">
                <el-link  :underline="isUnderline" v-if="two.linkUrl !== '' && two.linkUrl !== undefined"
                          style="padding-left: 2rem" @click="liItemEvent(item.index, two.linkUrl)">
                  {{two.title}}
                </el-link>
                <el-row v-else>
                  <el-divider content-position="left" class="title-second">{{two.title}}</el-divider>
                  <el-col style="padding-left: 2rem" >
                    <el-link v-for="(three,index4) in two.sub" :key="index + '-' + index2 + '-' + index3 + '-' + index4"
                            :underline="isUnderline" @click="liItemEvent(item.index, three.linkUrl)"
                            v-if="!three.hidden">
                      {{three.title}}
                    </el-link>
                  </el-col>
                </el-row>
              </div>
            </div>
            </el-col>
            </div>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
  import Foot from '../components/Foot.vue'
  import common from '../assets/js/common.js'

  import {mapState} from "vuex";

  export default {
    mixins: [common],
    data() {
      return {
        isUnderline: false,
        activeName: 0
      };
    },
    created () {
      this.handleActiveTab();
    },
    components: {
      Foot: Foot,
    },
    computed: {
      ...mapState(["menuList"])
    },
    methods: {
      liItemEvent(pre, linkUrl) {
        if (linkUrl) {
          if (pre.indexOf("/") !== 0) {
            pre = '/' + pre
          }
          this.$router.push({path: pre + '/' + linkUrl})
        }
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      handleActiveTab() {
        let indexList = this.menuList.find((item, index) => {
          if (item.hidden !== true) {
            this.activeName = index + ''
            return item
          }
        })
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import '../assets/less/var.less';

  .suport {
    /* background-color: white; */
    .content {
      padding: 50px 20px;
      max-width: 960px;
      width: 80%;
      margin: 0 auto;
      .suportMsg {
        padding: 30px 20px;
        box-sizing: border-box;
        // min-height: 1050px;
        background: @bgc;
        border: @bdr;
        @media screen and (max-width: 1200px) {
          // min-height: 1130px;
        }
        .el-divider__text {
          background-color: @bgc;
          /*font-size: 16px;*/
          color: #111B29;
          font-weight: bold;
        }
        .title-second {
          .el-divider__text {
            font-size: 12px;
            color: #333333;
          }
        }
        .item1 {
          padding-left: 50px;
          height: 320px;
        }
        .item2 {
          padding-left: 50px;
          height: 350px;
        }
        .item3 {
          padding-left: 50px;
          height: 230px;
        }
        .item4 {
          padding-left: 50px;
          height: 600px;
        }
        .item5 {
          padding-left: 50px;
          height: 200px;
        }
        .main-title {
          margin: 10px 0;
        }
        .label-top-title, .label-second-title {
          font-size: 16px;
          color: #111B29;
          margin: 10px 0;
          line-height: normal;
          padding-top: 2rem;
          font-weight: bold;
        }
        .label-second-title {
          font-size: 14px;
        }
        h3 {
          // font-family: @contT6;
          font-size: 16px;
          color: #111B29;
          margin: 0;
          margin-bottom: 10px;
          line-height: normal;
          padding-top: 2rem;
        }
        el-col {
          padding-left: 50px;
        }
        ul {
          margin: 0;
          padding: 0;
        }
        span {
          // font-family: @contT3;
          font-size: 12px;
          color: rgba(17, 27, 41, 0.78);
          list-style-type: none;
          padding: 3px 0;
          line-height: normal;
          cursor: pointer;
          margin: 5px 10px;
        }
        span:hover {
          color: #20a0ff;
        }
        a:hover {
          text-decoration: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Support.vue